/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type CardStatus = typeof CardStatus[keyof typeof CardStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardStatus = {
  active: 'active',
  'pending-issue': 'pending-issue',
  'pending-activation': 'pending-activation',
  locked: 'locked',
  suspended: 'suspended',
  cancelled: 'cancelled',
} as const;
